<template>
  <three-step-approval
    api="home-bill-delete-request"
    perm-prefix="approve_delete_bill_home"
    :columns="columns"
    final-word="ລຶບ"
    search-label="ຄົ້ນຫາ: ຊື່, ເບີໂທ, CUS_, ເລກບິນ"
    :final-confirm="(n) => `ລຶບບິນສາຍບ້ານ ${n} ໃບ? ບິນທີ່ລຶບແລ້ວຈະເຫັນຢູ່ໜ້າປະຫວັດ.`"
  />
</template>

<script>
import ThreeStepApproval from '@/views/threeStep/ThreeStepApproval.vue';

export default {
  name: 'HomeBillDeleteApproval',
  components: { ThreeStepApproval },
  title() {
    return 'Vientiane Waste Co-Dev|Home Bill Delete Approval';
  },
  data() {
    return {
      columns: [
        { text: 'ບິນ', value: 'bill_number' },
        { text: 'ລູກຄ້າ', value: 'customer_name' },
        { text: 'ຍອດເງິນ', value: 'total', align: 'end' },
      ],
    };
  },
};
</script>
